module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point04_05_activity-f8537741ce6f648b5b4eaf40cac17584.jpg";